import './faqs.css';

export default (element, data) => {
  var faqs = document.querySelectorAll('.faq__question');
  faqs.forEach(function (e) {
    e.addEventListener('click', function () {
      var answer = document.querySelector(
        '#' + e.attributes['aria-controls'].value,
      );
      if (e.attributes['aria-expanded'].value === 'false') {
        e.setAttribute('aria-expanded', true);
        e.classList.add('expanded');
        answer.setAttribute('aria-hidden', false);
        answer.classList.add('expanded');
      } else {
        e.setAttribute('aria-expanded', false);
        e.classList.remove('expanded');
        answer.setAttribute('aria-hidden', true);
        answer.classList.remove('expanded');
      }
    });
  });
};
